export const formatValue = (
  value,
  { isCurrency = true, decimalPlaces = 5 },
) => {
  // Return default value for null or undefined
  if (!value) return isCurrency ? '€0.00' : '0';

  // Default options for number formatting
  const formatOptions = {
    currency: isCurrency ? 'EUR' : undefined,
    style: isCurrency ? 'currency' : 'decimal',
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  };

  return new Intl.NumberFormat('en-NL', formatOptions).format(value);
};
